export default "/images/vendor/flag-icons/flags/1x1/to.svg?2cb4df0a0e3875c3c113a239aa7f0570";